// 语言环境配置
export function getLang() {
  return {
    display: {
      en: 'English',
      zh_CN: '中文',
      ko:'한국어',
      jp:'日本語',
    },
    transform: {
      en: 'en',
      zh_CN: 'zh',
       ko:'ko',
       jp:'jp',
    },
  }
}
// 判断是否是json格式的字符串
export function isJSON(str) {
  if (typeof str === 'string') {
    try {
      var obj = JSON.parse(str)
      if (typeof obj === 'object' && obj) {
        return true
      } else {
        return false
      }
    } catch (e) {
      return false
    }
  } else {
    return false
  }
}